import { useNavigate } from "react-router-dom";
import { ErrorComponent, PageLayout } from "shared";
import ErrorImg from "assets/images/error-robot.png";
import { useAppScope } from "master/contexts";
import { MwcdLogoComopent, PageNotFoundText } from "..";

export const PageNotFound = () => {
  const navigate = useNavigate();
  const { lanSettings } = useAppScope();

  const goToPreviousPage = () => {
    navigate(-1, { replace: true });
  };


  return (
    <PageLayout isPageEmpty={true} isBreadCrumbsRequired={false}>
      <div className="d-flex justify-content-end pb-3 mt-3">
        <MwcdLogoComopent customClass="logo-group-mwcd_PD marati_logo_empty_page" />
      </div>
      <div style={{ height: "80%" }}>
        <ErrorComponent
          title={`${PageNotFoundText.title[lanSettings?.lan || "en"]}`}
          message={`${PageNotFoundText.description[lanSettings?.lan || "en"]}`}
          image={ErrorImg}
          btnLabel={`${PageNotFoundText.button[lanSettings?.lan || "en"]}`}
          onClick={goToPreviousPage}
        />
      </div>
    </PageLayout >
  );
};
